import { fetchResources, forOwner, forQuery, set } from '../../_stores/_storeMethods'

export default {
  namespaced: true,
  state: {
    collection: []
  },
  mutations: {
    set
  },
  actions: {
    fetch(context) {
      return fetchResources(context, '/attachments')
    }
  },
  getters: {
    forOwner,
    forQuery
  }
}
